<div class="modal-header">
  <h4 class="modal-title">Change Email Address</h4>
</div>

<div class="modal-body" ngbAutofocus>
  @if (!success) {
    <div class="m-b-15">
      <div class="sm">Current email</div>
      <strong>{{ user?.email }}</strong>
    </div>

    <div class="alert alert-warning t-13">
      This changes the address the customer signs in with. It updates Cognito, the customer database, Iterable, both Stripe accounts, Zendesk, Shopify and their community profile, and
      <strong>signs them out of every device</strong>
      . Only do this once you have verified who you are talking to.
    </div>

    <div class="form-group">
      <span class="sm">New email</span>
      <input class="form-control" type="email" autocomplete="off" [(ngModel)]="newEmail" (ngModelChange)="emailChanged()" [disabled]="loading" />
      @if (newEmail && !newEmailIsValid) {
        <div class="text-danger t-12 m-t-5">That doesn't look like a valid email address.</div>
      }
      @if (sameAsCurrent) {
        <div class="text-danger t-12 m-t-5">That's already this user's email address.</div>
      }
      @if (checking) {
        <div class="sm m-t-5">
          <fa-icon icon="spinner" animation="spin" class="m-r-5"></fa-icon>
          Checking availability...
        </div>
      }
      @if (!checking && availability?.available === true) {
        <div class="text-success t-12 m-t-5">This address is available.</div>
      }
      @if (!checking && availability?.available === false) {
        <div class="text-danger t-12 m-t-5">
          <strong>Already in use.</strong>
          @for (conflict of availability.conflicts; track conflict.store) {
            <div>{{ conflict.detail }}</div>
          }
        </div>
      }
    </div>

    <div class="form-group">
      <span class="sm">Confirm new email</span>
      <input class="form-control" type="email" autocomplete="off" [(ngModel)]="confirmEmail" [disabled]="loading" />
      @if (confirmEmail && !emailsMatch) {
        <div class="text-danger t-12 m-t-5">The two addresses don't match.</div>
      }
    </div>

    <div class="form-group">
      <span class="sm">Reason (required)</span>
      <textarea class="form-control" rows="2" placeholder="e.g. Zendesk #12345 — customer lost access to their old mailbox" [(ngModel)]="reason" [disabled]="loading"></textarea>
      <div class="sm t-12 m-t-5">Recorded as a note on this customer's profile.</div>
    </div>

    @if (error) {
      <div class="alert alert-danger t-13">{{ error }}</div>
    }

    <div class="m-t-15">
      <span class="btn btn-primary m-r-10" (click)="submit()" [class.disabled]="!canSubmit">
        @if (loading) {
          <fa-icon icon="spinner" animation="spin" class="m-r-5"></fa-icon>
        }
        {{ loading ? "Changing Email..." : "Change Email" }}
      </span>
      <span class="btn btn-secondary" (click)="activeModal.dismiss()" [class.disabled]="loading">Cancel</span>
    </div>
  } @else {
    <div class="alert alert-success t-13">
      Email changed to
      <strong>{{ submittedEmail }}</strong>
      . The customer has been signed out of all devices and must sign in with the new address.
    </div>

    @if (failedResults.length) {
      <div class="alert alert-warning t-13">The email itself changed successfully, but {{ failedResults.length }} system(s) did not sync and may need a manual retry.</div>
    }

    <!-- fui-table rather than Bootstrap's .table: it uses semi-transparent greys that read on
         either background, where .table paints a light one and goes white-on-black in dark mode.
         It is also what every other key/value list in web-admin uses. -->
    <div class="fui-table">
      @for (result of results; track result.system) {
        <div class="fui-row">
          <div class="fui-label">{{ result.label }}</div>
          <div class="fui-value">
            @if (result.status === "ok") {
              <span class="text-success">Updated</span>
            }
            @if (result.status === "skipped") {
              <span class="sm">Not applicable</span>
            }
            @if (result.status === "failed") {
              <span class="text-danger">Failed</span>
            }
            @if (result.detail) {
              <span class="sm">{{ result.detail }}</span>
            }
          </div>
        </div>
      }
    </div>

    <div class="m-t-15">
      <span class="btn btn-primary" (click)="done()">Done</span>
    </div>
  }
</div>
